import { cacheResult } from '../../actions/cache';

export const toCache = (query, result) =>
  !result.cached ? { [JSON.stringify(query)]: { ...result, cached: true } } : {};

export const getCachedResult = (cache, query) => {
  return !!cache && cache.cacheEnabled && cache[JSON.stringify(query)];
};

export const applyCache = (eventQueries, fn, dispatch, getState) => {
  const state = getState();

  const { cachedResult, queries } = eventQueries.reduce(
    (result, query, idx) => {
      const resultFromCache = getCachedResult(state.cache, query);

      return resultFromCache
        ? {
            ...result,
            cachedResult: { ...result.cachedResult, [idx]: resultFromCache },
          }
        : { ...result, queries: [...result.queries, query] };
    },
    {
      cachedResult: {},
      queries: [],
    }
  );

  return fn(queries).then((response) => {
    const cache = queries.reduce(
      (totalCache, query, index) => ({ ...totalCache, ...toCache(query, response[index]) }),
      {}
    );
    dispatch(cacheResult({ cache }));

    const responseCopy = [...response];

    return eventQueries.map((item, idx) => cachedResult[idx] || responseCopy.shift());
  });
};
